<template lang="html">
  <nav class="nav" :class="{ 'in-builder-mode': inBuilderMode }">
    <div class="left-items">
      <div @click="toggleNav" class="burger">
        <Sprite name="menu" />
      </div>
      <transition name="slide-up">
        <router-link
          class="back-arrow"
          v-if="showBackLink"
          :to="{
            name: 'websites',
            params: { id: this.companyId }
          }">
          <Sprite name="grid" />
          <span>All Sites</span>
        </router-link>
      </transition>
    </div>
    <ul>
      <li>
        <router-link @click.native="closeNav" exact :to="{name: 'whats-new'}">
          <span>What's New?</span>
        </router-link>
      </li>
    </ul>
  </nav>
</template>

<script>
import Sprite from '@/components/Sprite'

export default {
  name: 'TopNav',

  computed: {
    showBackLink() {
      return this.$route.meta.hideSidebar
    },

    inBuilderMode() {
      return this.$route.meta.hideSidebar
    }
  },

  props: {
    companyId: String
  },

  components: {
    Sprite
  },

  methods: {
    toggleNav() {
      this.$emit('toggleNav')
    }
  }
}
</script>

<style lang="sass">
@import '../stylesheets/base/variables'
@import '../stylesheets/base/theme'
@import '../stylesheets/base/animations'
@import '../stylesheets/helpers/mixins'

.nav
  display: flex
  justify-content: space-between
  align-items: center
  color: #fff
  padding: 0 $gap-small
  position: sticky
  transition: height .3s ease-in-out
  height: $nav-height
  top: 0
  box-shadow: 0 0 5px rgba(0, 0, 0, 0.15)

  &.in-builder-mode
    height: 0

  @include themify($themes)
    background: themed('color-tertiary')

  @include media($media-gt-small)
    padding: 0 $gap-medium

    .animate &
      animation: nav .5s .6s ease-in-out
      animation-fill-mode: forwards
      transform: translateY(-100%)

  .sprite
    fill: #fff
    width: 20px
    height: 20px

    @include media($media-gt-small)
      position: absolute
      left: -25px

  a, .logout
    color: #fff!important
    display: flex
    align-items: center
    text-transform: uppercase
    font-weight: bold
    padding: 0
    position: relative

    span
      display: none

      @include media($media-gt-small)
        display: block
        margin-left: $gap-x-small

  .back-arrow
    .sprite
      width: 20px
      height: 20px
      position: initial
      margin-right: $gap-x-small

  .burger
    margin-right: $gap-small
    width: 20px
    height: 20px

    .sprite
      position: initial

    @include media($media-gt-medium)
      display: none

  ul
    list-style: none
    margin: 0

  li
    display: inline-block
    margin-right: $gap-small

    @include media($media-gt-small)
      margin-right: $gap-x-large

    &:last-child
      margin: 0

.left-items
  display: flex
  align-items: center
</style>
